function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  transform: "translate(1 3)"
}, React.createElement("path", {
  d: "M7.79166667,12.375 C7.79166667,13.3833333 9.22808333,14.2083333 11,14.2083333 C12.7719167,14.2083333 14.2083333,13.3833333 14.2083333,12.375 L18.7916667,12.375 L18.7916667,1.98641667 C18.7916667,1.14247955 18.1075205,0.458333333 17.2635833,0.458333333 L4.73641667,0.458333333 C3.89247955,0.458333333 3.20833333,1.14247955 3.20833333,1.98641667 L3.20833333,12.375 L7.79166667,12.375 Z"
}), React.createElement("path", {
  d: "M14.2083333,12.375 C14.2083333,13.3833333 12.7719167,14.2083333 11,14.2083333 C9.22808333,14.2083333 7.79166667,13.3833333 7.79166667,12.375 L0.458333333,12.375 C0.99712096,14.5298478 2.93323207,16.0415488 5.15441667,16.0416667 L16.8455833,16.0416667 C19.0667679,16.0415488 21.002879,14.5298478 21.5416667,12.375 L14.2083333,12.375 Z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1.04348em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/web-browser.b2a8bce5.svg";
export { SvgComponent as ReactComponent };